import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowBottomItemThirdProps as Props } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';
import { showRecruitmentPageBrowsingRecruitments } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [applications, setApplications] = useState<Recruitment[]>([])

  useEffect(() => {
    const request = async () => {
      try {
        const response = await showRecruitmentPageBrowsingRecruitments(props.recruitmentId);
        setApplications(response.recruitments);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.recruitmentId]);

  useEffect(() => {
    const $slider = $('.js-recruitment-bottom-third')
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: true,
        autoplay: false,
        prevArrow: '<div class="recruitment__show__applications__slider--prev"></div>',
        nextArrow: '<div class="recruitment__show__applications__slider--next"></div>',
        responsive: [
          {
            breakpoint: 1050,
            settings: {
              arrows: false
            }
          }
        ]
      })
    }
  }, [applications])

  return (
    <Presentation
      {...props}
      applications={applications}
    />
  );
};
